import React from 'react'

const About = () => {
  return (
    <div>
      <h1 className="text-6xl mb-4">Github Finder</h1>
    </div>
  )
}

export default About